import { combineReducers, configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import reducer from './reducer';

const persistConfig = {
  key: 'root',
  storage,
};

const VhkStore = configureStore({
  reducer: persistReducer(persistConfig, combineReducers(reducer)),
  devTools: import.meta.env.VITE_APP_ENV !== 'production',
  middleware: [
    ...getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  ],
});

export const persistor = persistStore(VhkStore);

export type VhkState = ReturnType<typeof VhkStore.getState>;

export type AppDispatch = typeof VhkStore.dispatch;

export default VhkStore;
